import React, { useState, useEffect } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';
import { Link, useNavigate, useLocation } from 'react-router-dom'; 
import { auth, db } from '../../utils/firebase'; 
import { getStorage, ref, getDownloadURL } from 'firebase/storage'; 
import { storage } from '../../utils/firebase'; 
import { doc, getDoc } from 'firebase/firestore'; 
import './Navbar.css';
import { toast } from 'react-toastify'; 
import 'react-toastify/dist/ReactToastify.css';  

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [imageUrl, setImageUrl] = useState('');
  const [image1Url, setImage1Url] = useState('');
  const [image2Url, setImage2Url] = useState('');
  const [image4Url, setImage4Url] = useState('');
  const [image3Url, setImage3Url] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false); 
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const fetchImages = async () => {
      try {
        // Fetch 'explorebacoor.png'
        const exploreImageRef = ref(storage, 'home/explorebacoor.png');
        const exploreUrl = await getDownloadURL(exploreImageRef);
        setImageUrl(exploreUrl);

        // Fetch '1.png'
        const image1Ref = ref(storage, 'home/1.png');
        const image1Url = await getDownloadURL(image1Ref);
        setImage1Url(image1Url);

        // Fetch '2.png'
        const image2Ref = ref(storage, 'home/2.png');
        const image2Url = await getDownloadURL(image2Ref);
        setImage2Url(image2Url);

        const image3Ref = ref(storage, 'home/33.png');
        const image3Url = await getDownloadURL(image3Ref);
        setImage3Url(image3Url);

        // Fetch '4.png'
        const image4Ref = ref(storage, 'home/4.png');
        const image4Url = await getDownloadURL(image4Ref);
        setImage4Url(image4Url);

      } catch (error) {
        console.error("Error fetching images:", error);
      }
    };

    fetchImages();
  }, []);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (user) {
        setIsLoggedIn(true);

        const userDoc = await getDoc(doc(db, "Users", user.uid));
        if (userDoc.exists() && userDoc.data().role === "admin") {
          setIsAdmin(true);
        } else {
          setIsAdmin(false);
        }
      } else {
        setIsLoggedIn(false);
        setIsAdmin(false);
      }
    });

    return () => unsubscribe();
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleLogout = async () => {
    try {
      await auth.signOut();
      setIsLoggedIn(false);
      setIsAdmin(false);
      navigate('/');
      closeModal();
      setIsOpen(false);
      toast.success("You have successfully logged out", {
        position: "top-center",
        autoClose: 500,
        style: {
          backgroundColor: '#4CAF50',
          color: 'white',
        },
      });
    } catch (error) {
      console.error("Error logging out: ", error);
      toast.error("Error logging out. Please try again.", {
        position: "top-center",
      });
    }
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-logo">
        <Link to="/">
          {imageUrl && <img src={imageUrl} alt="Explore Bacoor Logo" className="navbar-logo-img" />}
        </Link>
        
      </div>
      {!isAdmin && (
        <div className="inline-images-container">
          <div className="inline-images">
            <img src={image2Url} alt="Image 2" className="inline-image" />
            <img src={image1Url} alt="Image 1" className="inline-image" />
            <img src={image4Url} alt="Image 4" className="inline-image" />
            <img src={image3Url} alt="Image 3" className="inline-image" />
  
          </div>
        </div>
      )}
      
      <div className="navbar-container">
        <div className="burger" onClick={toggleMenu}>
          {isOpen ? <FaTimes /> : <FaBars />}
        </div>

        <div className={`nav-links ${isOpen ? 'open' : ''}`}>
          <Link to="/" className={location.pathname === '/' ? 'active' : ''}>
            <i className="bi bi-house-door" style={{ marginRight: '8px' }}></i>
            Home
          </Link>
          <Link to="/places" className={location.pathname === '/places' ? 'active' : ''}>
            <i className="bi bi-geo-alt" style={{ marginRight: '8px' }}></i>
            Places to Visit
          </Link>
          <Link to="/things" className={location.pathname === '/things' ? 'active' : ''}>
            <i className="bi bi-binoculars" style={{ marginRight: '8px' }}></i>
            Things to Do
          </Link>

          {isLoggedIn ? (
            <>
              <Link to="/profile" className={`profile-button ${location.pathname === '/profile' ? 'active' : ''}`}>
                <i className="bi bi-person" style={{ marginRight: '8px' }}></i>
                Profile
              </Link>
              {isAdmin && (
                <Link to="/adminusers" className={`admin-dashboard-button ${location.pathname === '/adminusers' ? 'active' : ''}`}>
                  <i className="bi bi-tools" style={{ marginRight: '8px' }}></i>
                  Admin Dashboard
                </Link>
              )}
              <button onClick={openModal} className="logout-button">
                <i className="bi bi-box-arrow-right" style={{ marginRight: '8px' }}></i>
                Logout
              </button>
            </>
          ) : (
            <Link to="/login" className={`login-button ${location.pathname === '/login' ? 'active' : ''}`}>
              <i className="bi bi-box-arrow-in-right" style={{ marginRight: '8px' }}></i>
              Login
            </Link>
          )}
        </div>
      </div>

      {/* Images displayed inline */}
    

      {isModalOpen && (
        <div className="modal">
          <div className="modal-content">
            <button className="modal-close" onClick={closeModal}>&times;</button>
            <h2>Are you sure you want to log out?</h2>
            <div className="modal-actions">
              <button onClick={handleLogout} className="modal-yes">
                <i className="bi bi-box-arrow-in-right"></i> Logout
              </button>
              <button onClick={closeModal} className="modal-no">
                <i className="bi bi-x-circle"></i> No
              </button>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
